// ============================================================
// Clipboard helper - copia + feedback "Copied" temporal.
//
// Reutilizado en SessionCard, SessionsTable, SessionDetailPanel,
// ParityCheckModal, WarmupParityModal, ChartAnalysis. Antes vivia
// duplicado en 3 componentes con copies con TTL distinto (1000ms vs
// 1500ms); unificamos a 1500ms.
// ============================================================

export async function copyText(text: string): Promise<boolean> {
  try {
    if (typeof navigator === 'undefined' || !navigator.clipboard) return false;
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('[clipboard] copy fallo', err);
    return false;
  }
}

/**
 * Helper para componentes Svelte 5: setea un flag a true durante 1500ms.
 * Uso:
 *   let copied = $state(false);
 *   async function onClick() {
 *     if (await copyText(sessionId)) flashCopied(() => (copied = true), () => (copied = false));
 *   }
 */
export function flashCopied(setOn: () => void, setOff: () => void, durationMs = 1500): void {
  setOn();
  setTimeout(setOff, durationMs);
}
